import React, { useEffect, useRef } from "react";

const FabricDebug = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        if (!canvasRef.current) return;

        const loadFabric = async () => {
            const { fabric } = await import("fabric");

            const canvas = new fabric.Canvas(canvasRef.current, {
                width: 800,
                height: 600,
                backgroundColor: "white",
            });

            // Rectangle
            const rect = new fabric.Rect({
                left: 50,
                top: 50,
                width: 200,
                height: 150,
                fill: "blue",
            });
            canvas.add(rect);

            // Circle
            const circle = new fabric.Circle({
                left: 350,
                top: 100,
                radius: 75,
                fill: "red",
            });
            canvas.add(circle);

            canvas.renderAll();
        };

        loadFabric();
    }, []);

    return (
        <div style={{ padding: "40px" }}>
            <h1>Fabric.js Test</h1>
            <canvas
                ref={canvasRef}
                style={{
                    border: "1px solid #ccc",
                    margin: "20px 0",
                }}
            />
        </div>
    );
};

export default FabricDebug;
